<template>
  <v-container pb-0>
    <v-layout row wrap class="form">
      <v-flex col xs12>
        <v-layout row wrap>
          <v-flex xs12 sm9>
            <span class="ticketTitleText">Event Name</span>
            <v-text-field
              class="inputText"
              :class="{
                'mr-2': $vuetify.breakpoint.smAndUp,
              }"
              :value="eventName"
              label="Enter the full event name"
              name="event"
              @input="$emit('update:eventName', $event)"
              :rules="[rules.required]"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3>
            <span class="ticketTitleText">Event Date</span>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
              @click.native="menu = true"
            >
              <v-text-field
                class="inputText"
                slot="activator"
                label="MM/DD/YYYY"
                @focus="menu = true"
                readonly
                v-model="eventDate"
                outline
              ></v-text-field>
              <v-date-picker
                v-model="unformattedEventDate"
                no-title
                scrollable
                actions
                :min="twoDaysDisabled"
                @input="event => selectDate(event)"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6>
            <span class="ticketTitleText">Event Venue</span>
            <v-text-field
              class="inputText"
              :class="{
                'mr-2': $vuetify.breakpoint.smAndUp,
              }"
              :value="eventVenue"
              label="Enter the name of the event venue"
              name="event"
              @input="$emit('update:eventVenue', $event)"
              :rules="[rules.required]"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <span class="ticketTitleText">Event City</span>
            <v-text-field
              class="inputText"
              :class="{
                'mr-2': $vuetify.breakpoint.smAndUp,
              }"
              :value="eventCity"
              label="Enter the city where the event is located"
              name="event"
              @input="$emit('update:eventCity', $event)"
              :rules="[rules.required]"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <span class="ticketTitleText">Event Country</span>
           <v-autocomplete
                class="addressInputField"
                :class="{
                  'mr-2': $vuetify.breakpoint.mdAndUp,
                }"
                :value="eventCountry"
                item-text="countryName"
                item-value="countryShortCode"
                :items="countriesList"
                @input="updateCountryClearState"
                label="Country"
                name="country"
                :rules="[rules.required]"
                outline
              ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6>
              <span class="ticketTitleText">Event State</span>
              <v-menu
                 content-class="statePopOver"

  offset-y
>
  <template v-slot:activator="{ on, attrs }">
    <div  v-bind="attrs"
        v-on="on">
       <v-text-field
        :value="selectedRegion"
        append-icon="arrow_drop_down"
        label="State/Province/Region"
        readonly
        outline
        class="stateContainer"
        :class="{
          'mr-2': $vuetify.breakpoint.smAndUp,
        }"
      ></v-text-field>
    </div>
  </template>
  <v-list :style="{
  'max-height': '300px', 'overflow-y': statesFromCountry.length === 0 ? 'unset' : 'scroll'
  }">
    <v-list-tile v-if="statesFromCountry.length === 0" class="stateEmptyItem" >
      <v-list-tile-title >
        No selection available.
      </v-list-tile-title>
    </v-list-tile>

    <div v-else
      v-for="item in statesFromCountry"
      :key="item.name"
    >
      <v-subheader
        v-if="item.children"
      >
        {{ item.name }}
      </v-subheader>
      <v-list-tile
        v-else
        @click="regionClick(item)"
      >
        <v-list-tile-content>
          <v-list-tile-title>{{ item.name }}e</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile
        @click="regionClick(child)"
        v-if="item.children"
        v-for="child in item.children"
        :key="child.name"
        >
          <v-list-tile-content>
            <v-list-tile-title>
              {{ child.name }}
            </v-list-tile-title>
          </v-list-tile-content>
      </v-list-tile>
    </div>
  </v-list>
</v-menu>
            </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { getCountriesList, getCountrySubdivisions, getChildSubdivisionMatchingCountryAndState } from '../utils/location';

export default {
  name: 'TheEvent',
  props: {
    eventName: {
      type: String,
      default: '',
    },
    eventDate: {
      type: String,
      default: '',
    },
    eventVenue: {
      type: String,
      default: '',
    },
    eventCity: {
      type: String,
      default: '',
    },
    eventCountry: {
      type: String,
      default: '',
    },
    eventState: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    unformattedEventDate: '',
    rules: {
      required: value => !!value || 'Required.',
    },
    menu: false,
    twoDaysDisabled: '',
    countriesList: getCountriesList().map(country => ({
      countryName: country.name,
      countryShortCode: country.alpha2,
    })),
    selectedRegion: '',
  }),
  mounted() {
    this.twoDaysDisabled = this.getEventDay();
    this.$nextTick(() => {
      const matchedState = getChildSubdivisionMatchingCountryAndState(this.eventCountry, this.eventState);
      this.selectedRegion = matchedState ? matchedState.name : '';
    });
  },
  methods: {
    updateCountryClearState($event) {
      this.$emit('update:eventCountry', $event);
      this.$emit('update:eventState', '');
      this.selectedRegion = '';
    },
    regionClick(region) {
      this.selectedRegion = region.name;
      this.$emit('update:eventState', region.code.slice(3));
    },
    selectDate(event) {
      this.unformattedEventDate = event;
      const formattedEvent = this.$$moment.dateSlashes(event);
      this.menu = false;
      this.$emit('update:eventDate', formattedEvent);
    },
    getEventDay() {
      let twoDaysDisabled = new Date();
      const ddTwoDays = String(twoDaysDisabled.getDate() + 2).padStart(2, '0'); // 2 days, or 48 hours disabled from current date.
      const mm = String(twoDaysDisabled.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy = twoDaysDisabled.getFullYear();

      twoDaysDisabled = `${yyyy}-${mm}-${ddTwoDays}`;

      return twoDaysDisabled;
    },
  },
  computed: {
    statesFromCountry() {
      const statesList = getCountrySubdivisions(this.eventCountry);
      return statesList;
    },
  },
};
</script>

<style scoped>
.statePopOver {
  margin-top: -26px;
}

.stateContainer {
  font-Size: 16px;
  font-weight: 500;
  color: black;
  justify-content: center;
}

.appDescriptionContainer {
  padding-top: 0px;
}

.ticketTitleText {
  font-family: Gotham;
  font-size: 16px;
  color: #333;
}

.inputText {
  font-family: Gotham;
  font-size: 16px;
  color: #999;
}

 /* Tablet Break Point */
@media screen and (max-width: 1264px) {
  .description {
    width: 695px;
    height: 90px;
  }
}

/* Mobile Break Point */
@media screen and (max-width: 767px) {
  .appDescriptionContainer {
    padding-top: 0px;
  }

  .description {
    width: 266px;
    height: 160px;
  }
}
</style>
